var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-background"},[_c('div',{staticClass:"background-placeholder",style:({ backgroundImage: ("url(" + _vm.header_url + ")") })})])}
var staticRenderFns = []

export { render, staticRenderFns }